import {
  WSElement,
  WSPage,
  useIsMobile
} from "@wingspanhq/fe-component-library";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";
import { useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { Tabs } from "../../../../components/Tabs";

import { useModalAddCustomField } from "../../components/AddCustomFieldModal/useAddCustomFieldModal";
import { CustomFieldResourceTypeSlug } from "../../utils";
import { CustomFieldsTable } from "./CustomFieldsTable";

export function RouteCustomFields() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [currentCustomFieldResourceType, setCurrentCustomFieldResourceType] =
    useState(CustomFieldResourceType.PAYEE);

  const addCustomFieldModal = useModalAddCustomField({
    resourceType: currentCustomFieldResourceType
  });

  useEffect(() => {
    if (
      location.pathname.includes(
        `/member/data/custom-fields/${
          CustomFieldResourceTypeSlug[CustomFieldResourceType.PAYEE]
        }`
      )
    ) {
      setCurrentCustomFieldResourceType(CustomFieldResourceType.PAYEE);
    } else if (
      location.pathname.includes(
        `/member/data/custom-fields/${
          CustomFieldResourceTypeSlug[CustomFieldResourceType.LINE_ITEM]
        }`
      )
    ) {
      setCurrentCustomFieldResourceType(CustomFieldResourceType.LINE_ITEM);
    }
  }, [location.pathname]);

  return (
    <WSPage
      title="Custom fields"
      primaryButton={
        isMobile
          ? undefined
          : {
              name: "createCustomField",
              label: "Add custom field",
              onClick: () => {
                addCustomFieldModal.open({
                  resourceType: currentCustomFieldResourceType
                });
              }
            }
      }
    >
      <Tabs
        tabs={[
          {
            path: `/member/data/custom-fields/${
              CustomFieldResourceTypeSlug[CustomFieldResourceType.PAYEE]
            }`,
            label: "Contractor"
          },
          {
            path: `/member/data/custom-fields/${
              CustomFieldResourceTypeSlug[CustomFieldResourceType.LINE_ITEM]
            }`,
            label: "Line Item"
          }
        ]}
      />
      <WSElement>
        <Switch>
          <Route
            path={`/member/data/custom-fields/:resourceTypeSlug`}
            component={CustomFieldsTable}
          />
          <Redirect
            from="*"
            to={`/member/data/custom-fields/${
              CustomFieldResourceTypeSlug[CustomFieldResourceType.PAYEE]
            }`}
          />
        </Switch>
      </WSElement>
    </WSPage>
  );
}
